import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Balancetes from './demonstrativos';
import Documentos from './documentos';
import Assembleias from './assembleias';
import Editais from './editais';
import Parcerias from './parcerias';

const Transparencia = () => {

  const { secao } = useParams();
  const navigate = useNavigate();
  const [aberto, setAberto] = useState(secao || "assembleias");

  const toggle = (novaSecao) => {
    const novaAberta = aberto === novaSecao ? null : novaSecao;
    setAberto(novaAberta);

    if (novaAberta) {
      navigate(`/transparencia/${novaAberta}`, { replace: true });
    } else {
      navigate(`/transparencia`, { replace: true });
    }
  };


  useEffect(() => {
    document.title = 'Modular - ATHIS: Transparência';
  }, []);
  return (

  <div className="transparencia">
    <div className="item">
      <button onClick={() => toggle("assembleias")}>
        <h3>Assembleias</h3>{aberto === "assembleias" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </button>
      {aberto === "assembleias" && <Assembleias />}
    </div>

    <div className="item">
      <button onClick={() => toggle("balancetes")}>
        <h3>Demonstrativos Contábeis</h3>{aberto === "balancetes" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </button>
      {aberto === "balancetes" && <Balancetes />}
    </div>

    <div className="item">
      <button onClick={() => toggle("documentos")}>
        <h3>Atos de constituição</h3>{aberto === "documentos" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </button>
      {aberto === "documentos" && <Documentos />}
    </div>

    <div className="item">
      <button onClick={() => toggle("editais")}>
        <h3>Editais</h3>{aberto === "editais" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </button>
      {aberto === "editais" && <Editais />}
    </div>

    <div className="item">
      <button onClick={() => toggle("parcerias")}>
        <h3>Parcerias</h3>{aberto === "parcerias" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </button>
      {aberto === "parcerias" && <Parcerias />}
    </div>
  </div>

  );
};

export default Transparencia;

